import instance from "../Components/Apis/axios";

export const loadeUser = () => async (dispatch) => {
  try {
    dispatch({ type: "UserRequest" });
    const { data } = await instance.get(`admin/user`);
    dispatch({ type: "UserSuccess", payload: data });
  } catch (err) {
    dispatch({ type: "UserFail", payload: err.response.message });
  }
};

export const logout = () => async (dispatch) => {
  try {
    await instance.get(`admin/logout`);
    dispatch({ type: "LOGOUT_SUCCESS"});
  } catch (err) {
    dispatch({ type: "LOGOUT_FAIL", payload: err.response.message });
  }
};
